import { render, staticRenderFns } from "./TemplateSummaryContent.vue?vue&type=template&id=260fce6a&scoped=true&"
import script from "./TemplateSummaryContent.vue?vue&type=script&lang=ts&"
export * from "./TemplateSummaryContent.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSummaryContent.vue?vue&type=style&index=0&id=260fce6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260fce6a",
  null
  
)

export default component.exports